<template>
  <ODialog ref="dialog" :maxWidth="700" hideWhenLoading>
    <v-card v-if="row != null">
      <v-toolbar class="card-bar">
        <v-toolbar-title>
          RawdataEvent
          <small class="grey--text text--lighten-1"> #{{ row.id }} </small>
        </v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="$refs.dialog.$dismiss()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-dialog v-model="showingCardResultHelp" max-width="700">
        <v-card>
          <v-card-text
            class="d-flex flex-wrap py-3 px-0 children-px-6 children-py-3"
          >
            <OCol left>
              <ORow left v-for="(item, idx) in cardResponses" :key="idx">
                <div class="mono" style="width: 60px">{{ item.hexCode }}</div>
                <div class="mono" style="width: 60px">{{ item.code }}</div>
                <div>{{ item.label }}</div>
              </ORow>
            </OCol>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-card-text class="pa-3">
        <div class="v-row">
          <div class="h-row-top">
            <div class="oderon-col-6" style="position: relative; height: 300px">
              <HeartbeatsMap :heartbeats="[hb]" :highlighted="hb" />
            </div>
            <div class="oderon-col-6 v-row children-pa-3">
              <div class="cap-cont">
                <label>Módulo</label>
                <p>
                  <router-link :to="`/clients/${row.clientId}`">{{
                    row.clientId
                  }}</router-link>
                </p>
              </div>
              <div class="cap-cont">
                <label>Heartbeat</label>
                <p>
                  <router-link :to="`/heartbeats/${row.hbId}`">{{
                    row.hbId
                  }}</router-link>
                </p>
                <p style="font-size: 14px !important" class="mt-2">
                  (de {{ row.hbRecvOn | moment('YYYY-MMM-DD HH:mm:ss Z') }})
                </p>
              </div>
              <div class="cap-cont">
                <label>Escrito em</label>
                <p>{{ row.timestamp | moment('YYYY-MMM-DD HH:mm:ss Z') }}</p>
              </div>

              <div class="cap-cont">
                <label>Recebido em</label>
                <p>{{ row.createdAt | moment('YYYY-MMM-DD HH:mm:ss Z') }}</p>
              </div>
            </div>
          </div>

          <div class="h-row-wrap children-pa-3">
            <div class="oderon-col-3 cap-cont">
              <label>Tipo</label>
              <p>
                <v-chip small dark label>
                  {{ row.type }}
                </v-chip>
              </p>
            </div>

            <div class="oderon-col-3 cap-cont">
              <label>str0</label>
              <p>
                <span class="mono">{{ row.str0 || '-' }}</span>
              </p>
            </div>
            <div class="oderon-col-3 cap-cont">
              <label>str1</label>
              <p>
                <span class="mono">{{ row.str1 || '-' }}</span>
                <a
                  class="ml-4"
                  @click="showingCardResultHelp = true"
                  v-if="row.type == 'card'"
                >
                  <v-icon color="blue darken-2" small>mdi-information</v-icon>
                </a>
              </p>
            </div>
            <div class="oderon-col-3 cap-cont">
              <label>num0</label>
              <p>
                <span class="mono">{{
                  row.num0 == null ? '-' : row.num0
                }}</span>
              </p>
            </div>

            <div class="oderon-col-3 cap-cont">
              <label>RawdataPointer</label>
              <p>
                {{ row.rdPointer }}
                (<span class="mono">0x{{ row.rdPointer | hex }}</span
                >)
              </p>
            </div>

            <div class="oderon-col-3 cap-cont">
              <label>LapseIndex</label>
              <p>{{ row.lapseIndex || '-' }}</p>
            </div>

            <div class="oderon-col-3 cap-cont">
              <label>Firmware</label>
              <p>
                {{ row.fwVersion }}
                (<span class="mono">0x{{ row.fwVersion | hex }}</span
                >)
              </p>
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </ODialog>
</template>

<script>
import { RawdataEvent } from '@/models'
import HeartbeatsMap from '../../components/heartbeats/map/HeartbeatsMap.vue'

export default {
  components: {
    HeartbeatsMap
  },
  data() {
    return {
      row: null,
      showingCardResultHelp: false,
      cardResponses: [
        {
          hexCode: '0x00',
          code: 'au',
          label: 'Card aceito, ignição desbloqueada'
        },
        {
          hexCode: '0x01',
          code: 'an',
          label: 'Card conhecido, mas não é motorista, bloqueio inalterado'
        },
        {
          hexCode: '0x02',
          code: 'rmv',
          label: 'Card conhecido, mas rejeitado pois veículo está em movimento'
        },
        {
          hexCode: '0x03',
          code: 'ruk',
          label: 'Card rejeitado porque não é conhecido/não foi embarcado'
        },
        {
          hexCode: '0x04',
          code: 're',
          label: 'Card conhecido, mas rejeitado porque está vencido'
        },
        {
          hexCode: '0x05',
          code: 'rne',
          label: 'Card conhecido, quase expirando (mas aceito)'
        },
        {
          hexCode: '0x06',
          code: 'rnd',
          label:
            'Card de jornada conhecido, mas rejeitado porque não é a hora correta de passar'
        },
        {
          hexCode: '0x07',
          code: 'auk',
          label:
            'Card aceito (partida liberada), mas desconhecido (ex: durante embarque)'
        },
        {
          hexCode: '0x08',
          code: 'rnj',
          label:
            'Card de Motorista conhecido, mas bloqueado por estar fora de jornada'
        }
      ]
    }
  },
  computed: {
    hb() {
      return {
        latitude: +this.row.lat,
        longitude: +this.row.lng,
        summary: {}
      }
    }
  },
  methods: {
    open(id) {
      this.row = null
      this.$refs.dialog.$loading(() => this.fetchData(id))
      return this.$refs.dialog.$open()
    },

    async fetchData(id) {
      this.row = await RawdataEvent.findById(id)
    }
  }
}
</script>

<style></style>
